import styled from 'styled-components';
import React from 'react'; // Import React
import { fadeInOnly, fadeInTransform } from '../../utils/animations'; // Assuming fadeInTransform is suitable
import logoImage from '../../assets/bm_logo.png';
import mainBackgroundImage from '../../assets/bm_main.jpg';

const HomeContainer = styled.div`
  background: ${(props) => props.theme.colors.background}; /* Updated */
  flex: 1;
  display: flex; /* Added to make BackgroundImage fill height if HomeContainer is the flex container from App.js */
`;

const BackgroundImage = styled.div`
  background-image: url(${mainBackgroundImage}); /* Use the new import */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  animation: ${fadeInOnly} 0.5s ease-in-out;
  animation-fill-mode: both;
  position: relative; /* For overlay and absolute positioning of children */
  display: flex; /* For centering children */
  flex-direction: column; /* Stack logo and title */
  flex: auto;
  align-items: center;

  &::before { /* Overlay */
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.4); /* Adjusted overlay opacity */
    z-index: 1;
  }
`;

const Image = styled.img`
  width: 200px; /* Adjusted size */
  height: 200px; /* Adjusted size */
  object-fit: contain;
  margin-bottom: 1rem; /* Space between logo and title */
  animation: ${fadeInTransform} 1.5s ease-out forwards; /* Adjusted animation */
  opacity: 0; /* Initial state for animation */
  z-index: 2; /* Above overlay */
  position: relative; /* Changed from absolute to flow with flexbox */

  @media (max-width: 480px) {
    width: 60px;
    height: 60px;
  }
`;

// No explicit props
interface HomeProps {}

const Home: React.FC<HomeProps> = () => {
  return (
    <HomeContainer>
      <BackgroundImage>
        <Image src={logoImage} alt="Blue Mountain Gurudwara Logo" /> {/* Use the new import */}
      </BackgroundImage>
    </HomeContainer>
  );
}

export default Home;
